/**
 * @generated SignedSource<<9f9da94384c26ec8d4ce409d5511390b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignSeriesEditorial_iconicDesignSeriesPage$data = {
  readonly editorialArticles: {
    readonly totalResults: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"EditorialModule_editorialArticles">;
  } | null;
  readonly " $fragmentType": "DesignSeriesEditorial_iconicDesignSeriesPage";
};
export type DesignSeriesEditorial_iconicDesignSeriesPage$key = {
  readonly " $data"?: DesignSeriesEditorial_iconicDesignSeriesPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesEditorial_iconicDesignSeriesPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignSeriesEditorial_iconicDesignSeriesPage",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 8
        }
      ],
      "concreteType": "WordpressArticlesType",
      "kind": "LinkedField",
      "name": "editorialArticles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditorialModule_editorialArticles"
        }
      ],
      "storageKey": "editorialArticles(first:8)"
    }
  ],
  "type": "IconicDesignSeriesPage",
  "abstractKey": null
};

(node as any).hash = "72a3b57fdca59041e86a2ff73fc9212b";

export default node;
